/**
 * Created by pzf on 2019/2/14
 *
 */
export default function format(data, valueKey, textKey) {
  data = data || [];
  return data.map(function (item) {
    if (!item.value) {
      item.value = item[valueKey];
    }

    if (!item.text) {
      item.text = item[textKey];
    }

    return item;
  });
}
//# sourceMappingURL=util.js.map
